// extracted by mini-css-extract-plugin
export default {"city":"current-city-btn-module__city--ZYR8M"};